<template>
  <v-container>
    <v-layout justify-center class="ma-0 mt-4">
      <v-card flat class="pl-3 pr-3" width="900">
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-flex md12 xs12>
              <v-layout>
                <v-flex md6 class="mr-3">
                  <v-select
                    v-model="idTurma"
                    :items="turmas"
                    label="Turma"
                    :item-text="
                      turma =>
                        `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
                    "
                    item-value="id"
                    hint="Seleciona a Turma"
                    persistent-hint
                    clearable
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>

                <v-flex md6>
                  <v-select
                    v-model="dia"
                    :items="dias"
                    label="Dia"
                    item-text="texto"
                    :item-value="id"
                    hint="Seleciona um dia da semana"
                    persistent-hint
                    clearable
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="search"
                label="Buscar"
                prepend-inner-icon="mdi-magnify"
              ></v-text-field>
            </v-flex>
          </v-card-text>
        </v-form>
      </v-card>
    </v-layout>
    <v-layout justify-center class="mt-3">
      <v-card flat width="900">
        <v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Aluno</th>
                  <th class="text-left">Lanche</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Suco</td>
                  <td>Bolo</td>
                  <td>Tudo</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="$refs.salvar.request()" color="primary">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { Turma, Cardapio, Produto } from '../../service'

export default {
  data() {
    return {
      turmas: [],
      produtos: [],
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      dias: [
        { id: 1, texto: 'Domingo' },
        { id: 2, texto: 'Segunda' },
        { id: 3, texto: 'Terça' },
        { id: 4, texto: 'Quarta' },
        { id: 5, texto: 'Quinta' },
        { id: 6, texto: 'Sexta' },
        { id: 7, texto: 'Sábado' }
      ],
      dia: ''
    }
  },
  async created() {
    await this.load()
  },
  methods: {
    async submit() {
      if (this.items.length > 0) {
        const res = await Cardapio.save(this.body, { escola: this.escola })
        this.$router.push(`/refeicoes/${res.id}`)
      }
    },

    async load() {
      this.turmas = await Turma.findAll({ escola: this.escola })
      this.produtos = await Produto.filter({ escola: this.escola })
    }
  }
}
</script>

<style></style>
